
import { useEffect, useState } from 'react';
import { Modal, Row, Col, Card, Badge, ProgressBar, Button } from 'react-bootstrap';
import config from "../../config/config";
import Loader from "../loader/Loader";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import MachineModal from '../modal/MachineModal';
import { formatDate } from '../../utils/formatDate';
import MachineSetupModal from '../modal/MachineSetupModal'
const IndividualMachineStatusModal = ({ show, handleClose, machineId, machineIds }) => {
  console.log("machineId",machineId,"machineIds",machineIds)
  const [showMachine, setShowMachine] = useState(false);
  const [mode, setMode] = useState('maintenance');
  const [loading, setLoading] = useState(false);
  const [productionData, setproductionData] = useState([]);
  const [machineSetup, setMachineSetup] = useState(false)
  //  const [machineSetupId, setMachineSetupId] = useState(null);
  const isManagerMode = !!machineIds;
  const fetchIndividualMachine = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const url = isManagerMode
        ? `${config.API}/supervisor/individualmachinestatus/${machineIds}`
        : `${config.API}/supervisor/individualmachinestatus/${machineId}`;

      const idToCheck = isManagerMode ? machineIds : machineId;
      if (!idToCheck) return;
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.success) {
        setproductionData(response.data);
      } else {
        setproductionData([]);
      }
    } catch (err) {
      console.error('Error fetchIndividualMachine:', err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (machineId || machineIds) {
      fetchIndividualMachine();
    }
  }, [machineId, machineIds]);
  const production = productionData?.log?.[0];
  const machine = production?.machine;
  const operators = productionData?.user || [];
  const totalOperators = productionData?.total_user || 0;
  const shift = production?.shift || "NA";
  const currentUnits = production ? Number(production.total_units_produced) : 0;
  const targetUnits = production ? Number(production.total_units) : 0;
  const nonConformities = production ? Number(production.total_units_rejected) : 0;
  const efficiency =
    targetUnits > 0
      ? ((currentUnits / targetUnits) * 100).toFixed(2)
      : 0;
  const openModal = (type) => {
    setMode(type);
    setShowMachine(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered className='font_family'>
        <Modal.Header closeButton>
          <strong className='fs-4'>Individual Machine Status</strong>
        </Modal.Header>
        {loading ? (
          <Loader />
        ) : (
          <Modal.Body className='font_family'>
            <Card className="mb-3 p-3 bg-light border-0">
              <div><strong>Machine Information</strong></div>
              <Row className='mt-2'>
                <Col md={6}>
                  <div>Code: <span className="fw-semibold">{machine?.machine_code}</span></div>
                  <div>Section: <span className="fw-semibold">{machine?.name}</span></div>
                </Col>
                <Col md={6}>
                  <div>Type: <span className="fw-semibold">{machine?.type}</span></div>
                  <div>
                    Status:{' '}
                    <Badge bg="success-subtle"
                      className="p-2 px-2 rounded-pill text-dark">
                      {machine?.status}
                    </Badge>
                  </div>
                </Col>
              </Row>
            </Card>
            <Card className="mb-3 p-3 bg-light border-0">
              <div><strong>Operator Information</strong></div>
              <div className='mt-2'>
                Number of Operators: <span className="fw-semibold">{totalOperators}</span>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap">
                <span>Operators Name :</span>
                {operators.length > 0 ? (
                  operators.map((op) => (
                    <span
                      key={op.operator_id}
                      className="bg-white border rounded me-2 p-1 mt-1"
                    >
                      {op.user?.name}
                    </span>
                  ))
                ) : (
                  <span className="text-muted">No operators assigned</span>
                )}
              </div>
            </Card>
            <Row className="mb-2 align-items-center">
              <Col xs={12} className="mb-1">
                <span className="fw-semibold">Production Information</span>
              </Col>
              <Col xs={6} md={4}>
                <div>
                  <strong>Shift:</strong>{" "}
                  <span className="text-muted">{shift}</span>
                </div>
                <div className="mt-1">
                  <strong>Date:</strong>{" "}
                  <span className="text-muted">
                    {formatDate(machine?.created_at)}
                  </span>
                </div>
              </Col>
              <Col xs={6} md={4} className="text-md-end ms-auto">
                <strong>{efficiency}%</strong>
                <br />
                <small className="text-muted">Efficiency</small>
              </Col>
            </Row>
            <div className="fw-bold mb-1 d-flex justify-content-between">
              <span>{productionData?.product}</span>
              <span>{currentUnits} / {targetUnits}</span>
            </div>
            <ProgressBar
              now={targetUnits > 0 ? (currentUnits / targetUnits) * 100 : 0}
              className="mb-3"
              style={{ height: '10px' }}
              variant="primary"
            />
            <Row className="text-center mb-4 p-2">
              <Col className="bg-light py-3 rounded">
                <div className="fs-4 fw-bold">{currentUnits}</div>
                <div className="text-muted small">Units Produced</div>
              </Col>
              <Col className="bg-light py-3 rounded mx-2">
                <div className="fs-4 fw-bold">{targetUnits}</div>
                <div className="text-muted small">Target Units</div>
              </Col>
              <Col className="bg-light py-3 rounded">
                <div className="fs-4 fw-bold">{nonConformities}</div>
                <div className="text-muted small">Non-Conformities</div>
              </Col>
            </Row>
          </Modal.Body>
        )}
        <Modal.Footer style={{ borderTop: "none" }}>
          <div className="d-flex flex-wrap justify-content-end gap-2">
            {isManagerMode ? (
              <>
                <Button variant="secondary" onClick={()=> setMachineSetup(true)}>
                  Machine Setup
                </Button>
                <Button variant="dark" onClick={handleClose}>
                  Close
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outline-secondary"
                  onClick={() => openModal('maintenance')}
                >
                  Request Maintenance
                </Button>

                <Button
                  variant="dark"
                  onClick={() => openModal('breakdown')}
                >
                  Report Breakdown
                </Button>
              </>
            )}

          </div>
        </Modal.Footer>

      </Modal>
      {!isManagerMode && (
        <MachineModal
          show={showMachine}
          handleClose={() => setShowMachine(false)}
          mode={mode}
        />
      )}
      <MachineSetupModal
        show={machineSetup}
        machineSetupId={machineIds}
        handleClose={() => setMachineSetup(false)}
      />
    </>
  );
};

export default IndividualMachineStatusModal;